var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":"https://gif.toutimages.com/images/fete/bonne_fete/bonne_fetes_002.gif"}}),_c('HelloWorld',{attrs:{"msg":"BonneFete Alexandre Marcotte"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }